import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage, IntlProvider } from 'react-intl';

import Loader from 'common/pages/Loader';
import SimplePage from 'common/pages/SimplePage';
import { getTranslations } from 'modules/app/intl/selectors';
import { getDealerTimezone } from 'modules/entity/selectors';
import { getSelectedCustomerLanguage } from 'modules/customers/selectors';
import {
  is404Error,
  isReady as isReadySelector,
  hasError as hasErrorSelector,
} from 'modules/customers/selectors/leads';
import { getDefault404Message } from 'common/pages/pagesUtils';

/** @type {React.FC<undefined>} */
const UnsubscribePage = () => {
  const isReady = useSelector(isReadySelector);
  const hasError = useSelector(hasErrorSelector);
  const is404 = useSelector(is404Error);
  const translations = useSelector(getTranslations);

  const showError = isReady && hasError;
  const showContent = isReady && !hasError;
  const showLoading = !isReady;

  const timezone = useSelector(getDealerTimezone);
  const language = useSelector(getSelectedCustomerLanguage);

  return (
    <IntlProvider messages={translations} locale={language} timeZone={timezone}>
      <div id="page-wrapper" className="page">
        {showLoading && <Loader />}
        {!showLoading && (
          <SimplePage>
            {showError && (
              <>
                {!is404 && (
                  <FormattedMessage
                    id="web.leads.unsubscribe.failure"
                    defaultMessage="An error occurred when unsubscribing you."
                  />
                )}
                {is404 && getDefault404Message()}
              </>
            )}
            {showContent && (
              <FormattedMessage
                id="web.leads.unsubscribe.success"
                defaultMessage="You have successfully been unsubscribed."
              />
            )}
          </SimplePage>
        )}
      </div>
    </IntlProvider>
  );
};

export default UnsubscribePage;
